import { Auth } from 'aws-amplify';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Routes } from './config/routes';
import { logout } from './utils/auth';

function App({ initUser }) {
  useEffect(() => {
    Auth.currentSession()
      .then((session) => {
        if (!session.isValid()) {
          logout(() => {});
          return;
        }
        initUser().then(() => {
          // initCustomerAccount();
        });
      })
      .catch(() => {
        logout(() => {});
      });
  }, [initUser]);

  return <Routes />;
}

const stateMapper = () => ({});

const dispatchMapper = (dispatch) => ({
  initUser: dispatch.auth.fetchAndSetUser,
  // initCustomerAccount: dispatch.merchantAccount.fetchAndSetMerchantAccount,
});
export default connect(stateMapper, dispatchMapper)(App);
